import PropTypes from 'prop-types';
import '@styles/common/components/loader.scss';

const propTypes = {
  loader: PropTypes.oneOf(['bricks', 'circles']),
  message : PropTypes.string,
  size    : PropTypes.oneOf(['sm']),
};

function Loader({ loader = 'bricks', message, size }) {
  return (
    <div className={'loader' + (size ? ` loader--${size}` : '')}>
      {LoaderStyles[loader]}
      {message && (
        <div className="loader__message">{message}</div>
      )}
    </div>
  );
}

const LoaderStyles = {
  bricks: (
    <div className="bricks">
      <div className="brick"></div>
      <div className="brick"></div>
      <div className="brick"></div>
    </div>
  ),
  circles: ( // metlife
    <div className="circles">
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
    </div>
  ),
};

Loader.propTypes = propTypes;

export default Loader;
